export const SET_FAVORITES = "SET_FAVORITES";
